import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import DescriptionIcon from "@mui/icons-material/Description";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";

export { C } from "../ipd-billing/constants";

export const NAV_CONFIG = {
  key: "radiology",
  base: "",
  title: "Radiology",
  subtitle: "Studies & reports",
  icon: DocumentScannerIcon,
  groups: [
    {
      id: "workspace",
      label: "Workspace",
      items: [
        {
          id: "studies",
          label: "Tests & Examinations",
          icon: DocumentScannerIcon,
          path: "/radiology-services",
        },
        {
          id: "templates",
          label: "Report Templates",
          icon: DescriptionIcon,
          path: "/radiology-report-templates",
        },
      ],
    },
  ],
  footer: [
    {
      id: "go-home",
      label: "IPD Home",
      icon: LocalHospitalIcon,
      href: "/main-landing",
    },
  ],
};
